export default __webpack_public_path__ + "static/media/friendometer2.113078cb.jpg";